// Типы состояний и данных
// Основной интерфейс для состояния корзин
export interface CartsState {
  isLoading: {
    list: boolean;
    single: boolean;
    create: boolean;
    delete: boolean;
    commit: boolean;
    addItems: boolean;
    updateItem: boolean;
    deleteItem: boolean;
    suppliers: boolean;
    serchDetailsBySuppliers: boolean;
  };
  errors: {
    list: string | null;
    single: string | null;
    create: string | null;
    delete: string | null;
    commit: string | null;
    addItems: string | null;
    updateItem: string | null;
    deleteItem: string | null;
    suppliers: string | null;
    serchDetailsBySuppliers: string | null;
  };
  list: CartDTO | null;
  currentCart: CartDTO | null;
  suppliers: SuppliersListDTO[] | null;
  serchDetailsBySuppliers: SearchResultsProps | null;
}

// Интерфейс для основной корзины (CartDTO)
export interface CartDTO {
  status: number;
  number: number;
  pk: string;
  is_active: boolean;
  created_at: string;
  order_items: CartItemDTO[];
  user_id: string;
}

// Интерфейс для товаров в корзине (CartItemDTO)
export interface CartItemDTO {
  article_number: string;
  supplier: string;
  brand: string;
  status: number;
  comment: string;
  amount: number;
  price: string;
  delivery_term: number;
  good_name: string;
  pk: string;
  is_active: boolean;
}

export interface SearchResultsProps {
  items: SupplierDTO[];
  external: SupplierDTO[];
}

// Интерфейс для поставщика (SupplierDTO)
export interface SupplierDTO {
  name: string;
  brand: string;
  brand_article: string;
  amount: number;
  price: string;
  delivery_term: number;
  supplier_id: string;
  pk: string;
  is_active: boolean;
  isOriginal?: boolean; // Дополнительное свойство для группировки
}

// Интерфейс для списка поставщиков (SuppliersListDTO)
export interface SuppliersListDTO {
  name: string;
  pk: string;
  is_active: boolean;
}

// Интерфейс для продуктов (ProductDTO), преобразуемый из SupplierDTO
export interface ProductDTO {
  name: string;
  deliveryTime: string;
  price: string;
  stock: number;
  manufacturer: string;
  article: string;
  supplierId: string;
  id: string;
}

// Функция для преобразования SupplierDTO в ProductDTO
export function transformSupplierToProduct(supplier: SupplierDTO): ProductDTO {
  return {
    name: supplier.name,
    deliveryTime: `${supplier.delivery_term} дн.`,
    price: `${supplier.price} ₽`,
    stock: supplier.amount,
    manufacturer: supplier.brand,
    article: supplier.brand_article,
    supplierId: supplier.supplier_id,
    id: supplier.pk,
  };
}

// Константы для экшенов

// Список корзин
export const GET_CARTS_REQUEST = 'GET_CARTS_REQUEST';
export const GET_CARTS_SUCCESS = 'GET_CARTS_SUCCESS';
export const GET_CARTS_FAILURE = 'GET_CARTS_FAILURE';

// Получение корзины по ID
export const GET_CART_REQUEST = 'GET_CART_REQUEST';
export const GET_CART_SUCCESS = 'GET_CART_SUCCESS';
export const GET_CART_FAILURE = 'GET_CART_FAILURE';

// Создание корзины
export const CREATE_CART_REQUEST = 'CREATE_CART_REQUEST';
export const CREATE_CART_SUCCESS = 'CREATE_CART_SUCCESS';
export const CREATE_CART_FAILURE = 'CREATE_CART_FAILURE';

// Удаление корзины
export const DELETE_CART_REQUEST = 'DELETE_CART_REQUEST';
export const DELETE_CART_SUCCESS = 'DELETE_CART_SUCCESS';
export const DELETE_CART_FAILURE = 'DELETE_CART_FAILURE';

// Коммит корзины
export const COMMIT_CART_REQUEST = 'COMMIT_CART_REQUEST';
export const COMMIT_CART_SUCCESS = 'COMMIT_CART_SUCCESS';
export const COMMIT_CART_FAILURE = 'COMMIT_CART_FAILURE';

// Добавление товаров в корзину
export const ADD_ITEMS_REQUEST = 'ADD_ITEMS_REQUEST';
export const ADD_ITEMS_SUCCESS = 'ADD_ITEMS_SUCCESS';
export const ADD_ITEMS_FAILURE = 'ADD_ITEMS_FAILURE';

// Получение товара из корзины по ID
export const GET_CART_ITEM_REQUEST = 'GET_CART_ITEM_REQUEST';
export const GET_CART_ITEM_SUCCESS = 'GET_CART_ITEM_SUCCESS';
export const GET_CART_ITEM_FAILURE = 'GET_CART_ITEM_FAILURE';

// Обновление товара в корзине
export const UPDATE_CART_ITEM_REQUEST = 'UPDATE_CART_ITEM_REQUEST';
export const UPDATE_CART_ITEM_SUCCESS = 'UPDATE_CART_ITEM_SUCCESS';
export const UPDATE_CART_ITEM_FAILURE = 'UPDATE_CART_ITEM_FAILURE';

// Удаление товара из корзины
export const DELETE_CART_ITEM_REQUEST = 'DELETE_CART_ITEM_REQUEST';
export const DELETE_CART_ITEM_SUCCESS = 'DELETE_CART_ITEM_SUCCESS';
export const DELETE_CART_ITEM_FAILURE = 'DELETE_CART_ITEM_FAILURE';

export const SEARCH_SUPPLIERS_REQUEST = 'SEARCH_SUPPLIERS_REQUEST';
export const SEARCH_SUPPLIERS_SUCCESS = 'SEARCH_SUPPLIERS_SUCCESS';
export const SEARCH_SUPPLIERS_FAILURE = 'SEARCH_SUPPLIERS_FAILURE';

export const GET_SUPPLIERS_REQUEST = 'GET_SUPPLIERS_REQUEST';
export const GET_SUPPLIERS_SUCCESS = 'GET_SUPPLIERS_SUCCESS';
export const GET_SUPPLIERS_FAILURE = 'GET_SUPPLIERS_FAILURE';
